// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_xiaozhu@2022.4.8@xiaozhu/wechatapp/css/global_new.css
// module id = 90
// module chunks = 49